module.exports = __webpack_public_path__ + "static/media/rewind.9c1971d7.svg";